var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPubmedsearchLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60.447,
    height: 60.447,
    viewBox: "0 0 68.447 68.447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1113",
    d: "M0-682.665H68.447v68.447H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1107",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1109",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1111",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1117",
    transform: "translate(1.003 17.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1119",
    d: "M-34.19,0H-38V48.127H-6.784",
    transform: "translate(38)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1121",
    transform: "translate(36.229 65.439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1123",
    d: "M-58.582,0h-6.528",
    transform: "translate(65.111)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1125",
    transform: "translate(47.057 17.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1127",
    d: "M-148.756,0h3.81V48.127h-20.387",
    transform: "translate(165.333)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1129",
    transform: "translate(32.218 61.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1131",
    d: "M-35.989,0V4.278a2.006,2.006,0,0,1-2.005,2.005A2.006,2.006,0,0,1-40,4.278V0Z",
    transform: "translate(40)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1133",
    transform: "translate(40.239 36.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1135",
    d: "M0,0H2.586",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1137",
    transform: "translate(51.825 41.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1139",
    d: "M-51.993,0h-5.794",
    transform: "translate(57.787)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1141",
    transform: "translate(40.239 41.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1143",
    d: "M-73.394,0h-8.179",
    transform: "translate(81.573)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1145",
    transform: "translate(40.239 46.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1147",
    d: "M0,0H17.379",
    transform: "translate(0 0)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1149",
    transform: "translate(40.239 51.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1151",
    d: "M0,0H6.164",
    transform: "translate(0 0)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1153",
    transform: "translate(4.813 13.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1155",
    d: "M0-297.512v-33.154H5.822",
    transform: "translate(0 330.666)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1157",
    transform: "translate(4.813 13.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1159",
    d: "M-211.677,0h5.822V43.314h-29.411V37.5",
    transform: "translate(235.266)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1161",
    transform: "translate(34.223 13.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1163",
    d: "M-263.922-105.769v31.527h-29.411v-43.314h11.887",
    transform: "translate(293.333 117.556)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1165",
    transform: "translate(54.132 13.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1167",
    d: "M0,0H9.5V7.553",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1169",
    d: "M77.411-108.656H48v-4.011H77.411Z",
    transform: "translate(-43.187 169.817)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1171",
    d: "M370.743-108.656H341.332v-4.011h29.411Z",
    transform: "translate(-307.109 169.817)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1173",
    transform: "translate(46.111 1.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1175",
    d: "M-66.1-309.138h-6.711a.655.655,0,0,1-.655-.655v-31.856a1.939,1.939,0,0,1,1.938-1.938h4.144a1.938,1.938,0,0,1,1.938,1.938v31.856A.655.655,0,0,1-66.1-309.138Z",
    transform: "translate(73.469 343.587)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1177",
    transform: "translate(46.111 31.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1179",
    d: "M-66.1-35.989h-6.711a.655.655,0,0,1-.655-.655V-40h8.021v3.356A.655.655,0,0,1-66.1-35.989Z",
    transform: "translate(73.468 40)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1181",
    transform: "translate(46.111 7.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1183",
    d: "M-71.977-35.989H-80V-40h8.021Z",
    transform: "translate(79.998 40)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1185",
    transform: "translate(46.913 35.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1187",
    d: "M-23.776-69.611c-4.185-5.214-2.159-7.757-2.159-7.757H-20.5s2.028,2.544-2.159,7.757A.723.723,0,0,1-23.776-69.611Z",
    transform: "translate(26.426 77.368)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1189",
    transform: "translate(50.122 35.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1191",
    d: "M0,0V2.674",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1193",
    transform: "translate(17.513 30.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1195",
    d: "M-35.989,0V16.366a2.006,2.006,0,0,1-2.005,2.005A2.006,2.006,0,0,1-40,16.366V0",
    transform: "translate(40)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1197",
    transform: "translate(8.823 9.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1199",
    d: "M-95.972-191.943a10.707,10.707,0,0,1-10.695-10.695,10.707,10.707,0,0,1,10.695-10.695,10.707,10.707,0,0,1,10.695,10.695A10.707,10.707,0,0,1-95.972-191.943Z",
    transform: "translate(106.666 213.333)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPubmedsearchLarge);
export default __webpack_public_path__ + "static/media/pubmedsearch_large.fa053ca7822a01ea482ed9c4c893d947.svg";
export { ForwardRef as ReactComponent };